import { render } from "./Hold.vue?vue&type=template&id=5977f071"
import script from "./Hold.vue?vue&type=script&lang=js"
export * from "./Hold.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__